module.exports = __webpack_public_path__ + "img/tree_add_sub.89dc51b9.svg";